<template>
  <div class="editCube Msg">
    <div>{{title}}
      <SwitchVue v-if="isSwitch" :defaultValue="switchValue" @update="$emit('updateSwitch', $event)"/>
      <button v-if="!edit" class="editBtn" @click="data=value;$emit('edit')"><div></div></button>
    </div>
    <div :style="{display: 'flex', width: '100%', gap: '10px', fontSize: '20px'}" v-if="edit">
      <template  v-if="template">
      <button class="template" @click="data=template">範例訊息</button>
      </template>
      <Spring/>
      <div class="deftexts">
        基本資訊:
        <Spring/>
        <button class="deftext" @click="insertText('{預約日期}')">預約日期</button>
        <button class="deftext" @click="insertText('{預約時間}')">預約時間</button>
        <template v-if="notShop">
          <button class="deftext" @click="insertText('{人數}')">人數</button>
          <button class="deftext" @click="insertText('{大人小孩}')">大人小孩</button>
        </template>
        <button v-if="atm&&remit" class="deftext" @click="insertText('{匯款金額}')">匯款金額</button>
        <button class="deftext" @click="insertText('{訂單金額}')">訂單金額</button>
      </div>
    </div>
    <div :style="{display: 'flex', width: '100%', gap: '10px', fontSize: '20px'}" v-if="edit&&!atm">
      <Spring/>
      <div class="deftexts">
      線上付款資訊:
      <Spring/>
      <button class="deftext" @click="insertText('{交易日期}')">交易日期</button>
      <button class="deftext" @click="insertText('{訂單編號}')">訂單編號</button>
      <button class="deftext" @click="insertText('{付款方式}')">付款方式</button>
      <button class="deftext" @click="insertText('{付款序號}')">付款序號</button>
      </div>
    </div>
    <p v-if="!edit" v-html="data?(
      value
      .replaceAll('\n', '<br>')
      .replaceAll('{預約日期}', '<span>預約日期</span>')
      .replaceAll('{預約時間}', '<span>預約時間</span>')
      .replaceAll('{人數}', '<span>人數</span>')
      .replaceAll('{大人小孩}', '<span>大人小孩</span>')
      .replaceAll('{匯款金額}', '<span>匯款金額</span>')
      .replaceAll('{交易日期}', '<span>交易日期</span>')
      .replaceAll('{訂單編號}', '<span>訂單編號</span>')
      .replaceAll('{付款方式}', '<span>付款方式</span>')
      .replaceAll('{付款序號}', '<span>付款序號</span>')
      .replaceAll('{訂單金額}', '<span>訂單金額</span>')
    ):''"
      :style="{color: 'var(--color-letter)', lineHeight: '180%'}"></p>
    <label class="textinput" v-else for="textMessage">
      <textarea :style="{padding: '1em', lineHeight: '180%'}" ref="textMessage" v-model="data" id="textMessage" :disabled="!edit"/>
    </label>
    <div class="btns" v-if="edit">
      <button class="cancel" @click="$emit('cancel')">取消</button>
      <button class="confirm" @click="$emit('update', data)">儲存</button>
    </div>
  </div>
</template>

<script>
import SwitchVue from './radio/switch.vue'
export default {
  props: ['value', 'title', 'template', 'isSwitch', 'switchValue', 'edit', 'atm', 'remit', 'notShop'],
  components: { SwitchVue },
  data () {
    return {
      data: null
    }
  },
  async mounted () {
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.data = this.value
      }
    }
  },
  methods: {
    insertText (Content) {
      try {
        this.$refs.textMessage.focus()
        var mySelection = document.selection.createRange()
        mySelection.text = Content
        this.data = this.$refs.textMessage.value
      } catch (error) {
        try {
          var myPrefix = this.$refs.textMessage.value.substring(0, this.$refs.textMessage.selectionStart)
          var mySuffix = this.$refs.textMessage.value.substring(this.$refs.textMessage.selectionEnd)
          this.data = myPrefix + Content + mySuffix
        } catch (error) {
          console.log(error)
        }
      }
    }
  }
}
</script>
<style lang="scss">
.editCube.Msg {
  span {
    display: inline;
    padding: 4px 6px;
    color: #FFFFFF;
    width: fit-content;
    white-space: nowrap;
    height: fit-content;
    background-color: var(--color-checked);
    font-size: 18px;
    color: #FFFFFF;
    border-radius: 3px;
    margin-inline: 3px;
  }
}
</style>
<style lang="scss" scoped>
.deftexts {
  width: 580px;
  display: flex;
  gap: 10px;
}
button.template {
width: 90px;
height: 35px;
background: var(--color-bar);
border: 1px solid var(--color-checked);
border-radius: 3px;
color: var(--color-checked);
font-size: 14px;
line-height: 20px;
letter-spacing: 0.1em;
}
button.keytemp {
width: 90px;
height: 35px;
background: var(--color-bar);
border: 1px solid var(--color-checked);
border-radius: 3px;
color: var(--color-checked);
margin-left: 10px;
font-size: 14px;
line-height: 20px;
letter-spacing: 0.1em;
}
.deftext {
  padding-inline: 5px;
  height: 35px;
  background: var(--color-bar);
  border: 1px solid var(--color-checked);
  border-radius: 3px;
  color: var(--color-checked);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1em;
}
p {
  text-align: start;
  vertical-align: middle;
  border: 1px solid #CACACA;
  min-height: 200px;

}
.textinput {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 100%;
  z-index: 1;
  border: 1px solid #CACACA;
  &>textarea {
    position: relative;
    color: transparent;
    z-index: 3;
    min-height: 200px;
    background-color: transparent;
    color: var(--color-letter);
  }
  &>p {
    position: relative;
    border: 1px solid var(--color-border);
    color: var(--color-letter);
    z-index: 2;
  }
}
.editCube {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-checked);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 9px;
  textarea, p {
    margin: 0;
    padding: 7px 20px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0.1em;
    width: -webkit-fill-available;
    height: -webkit-fill-available;
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button.editBtn {
      margin-left: auto;
      width: 32px;
      height: 32px;
      background-color: var(--color-checked);
      border: none;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      &>div{
        width: 16px;
        height: 16px;
        background-color: #FFFFFF;
        mask-image: url(/pen.svg);
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: contain;
      }
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
